import { DuplicateReason, isConfirmReason } from './duplicateFileName';

export type DuplicateMatchStatus = 'pending' | 'active' | 'deleted' | 'selection';

export interface DuplicateMatch {
  id: string;
  fileName: string;
  status: DuplicateMatchStatus;
  pageCount?: number;
  reasons: DuplicateReason[];
}

export interface DuplicateDecisionRequest {
  fileName: string;
  matches: DuplicateMatch[];
}

export interface DuplicateCheckResult {
  matches: DuplicateMatch[];
  ewayBillNumbers: string[];
  documentNumbers: string[];
  invoiceNumbers: string[];
  podNumbers: string[];
}

type Waiter = {
  request: DuplicateDecisionRequest;
  resolve: (proceed: boolean) => void;
};

const waiters: Waiter[] = [];
let emit: (() => void) | null = null;

export function bindDuplicateDecisions(listener: () => void): () => void {
  emit = listener;
  if (waiters.length > 0) listener();
  return () => {
    if (emit === listener) emit = null;
  };
}

export function peekDuplicateDecision(): Waiter | null {
  return waiters[0] || null;
}

export function settleDuplicateDecision(proceed: boolean): void {
  const waiter = waiters.shift();
  waiter?.resolve(proceed);
  emit?.();
}

/** Asks the mounted dialog. If no dialog is mounted, the upload continues. */
export function requestDuplicateDecision(request: DuplicateDecisionRequest): Promise<boolean> {
  if (!request.matches.length) return Promise.resolve(true);
  return new Promise((resolve) => {
    waiters.push({ request, resolve });
    if (emit) {
      emit();
      return;
    }
    setTimeout(() => {
      if (emit) {
        emit();
        return;
      }
      const index = waiters.findIndex((waiter) => waiter.resolve === resolve);
      if (index >= 0) {
        waiters.splice(index, 1);
        resolve(true);
      }
    }, 0);
  });
}

export function billMatches(matches: DuplicateMatch[]): DuplicateMatch[] {
  return matches
    .map((match) => ({
      ...match,
      reasons: match.reasons.filter((reason) => isConfirmReason(reason)),
    }))
    .filter((match) => match.reasons.length > 0);
}
